import { QuizQuestion } from '@shared/types';

interface TextInputProps {
  question: QuizQuestion;
  value: string;
  onChange: (value: string) => void;
  onFinished?: (value: string) => void;
}

export default function TextInput({ question, value = '', onChange, onFinished }: TextInputProps) {
  const multiline = question.multiline === true;

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (!multiline && e.key === 'Enter' && value.trim()) {
      onFinished?.(value);
    }
  };

  const handleBlur = () => {
    if (value.trim()) {
      onFinished?.(value);
    }
  };

  const inputClassName = "input text-lg";

  if (multiline) {
    return (
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={handleBlur}
        placeholder={question.placeholder}
        className={`${inputClassName} min-h-[6.5rem] resize-y`}
        rows={4}
      />
    );
  }

  return (
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      placeholder={question.placeholder}
      className={inputClassName}
    />
  );
}
